import styled from "styled-components";

export const Image = styled.img`
  height: 200px;
  border-radius: 8px;
  width: 100%;
  object-fit: fill;
  margin-top: 30px;
`;
